module.exports = __webpack_public_path__ + "static/media/animalproduct.0c7ff5b8.png";